<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form 
          class="search" 
          :inline="true" 
          label-suffix="：" 
          size="mini" 
          :model="search"
          @submit.native.prevent
        >
        
          <el-form-item label="订单类别">
            <el-select v-model="search.type" placeholder="请选订单类别" class="w120" @change="getList">
              <el-option
                v-for="item in options.typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="成交日期">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              class="w220"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="searchTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称" v-if="!clienId">
            <el-input
              v-model="search.consignee"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="门店名称" v-if="!clienId">
            <el-input
              v-model="search.shop_name"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="收款金额" >
            <el-input
              v-model="search.low_total"
              maxlength="30"
              class="w84"
              placeholder="最小值"
              clearable
              oninput="value=value.replace(/[^0-9.]/g,'')"
            />
            <span>-</span>
            <el-input
              v-model="search.large_total"
              maxlength="30"
              class="w84"
              placeholder="最大值"
              clearable
              oninput="value=value.replace(/[^0-9.]/g,'')"
            />
          </el-form-item>
          <el-form-item label="业务类型">
            <el-select v-model="search.business_type" placeholder="请选业务类型" class="w120" clearable>
              <el-option
                v-for="item in options.business_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="search.order_type" placeholder="请选订单类型" class="w120" clearable>
              <el-option
                v-for="item in options.order_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单来源">
            <el-select v-model="search.is_app" placeholder="请选订单来源" class="w120" clearable>
              <el-option
                v-for="item in options.is_app_List"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
        <div class="btnBox">
            <div v-if="userInfo.shop_id"></div>
        </div>
        <!--列表-->
        <el-row>
            <el-col :span="23">
            <el-table
                :data="list"
                size="small"
                border
                v-loading="loading"
                :cell-style="cellStyle"
                :header-cell-style="rowClass"
            >
                 <ElTableColumn label="订单类别" prop="type" >
                   <template slot-scope="scope">
                    {{ scope.row.type == 3 ? '收款单' : '出库单' }}
                  </template>
                </ElTableColumn>
                <ElTableColumn label="成交日期" prop="deal_time" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.deal_time ?scope.row.deal_time : '-' }}
                  </template>
                </ElTableColumn>
                <ElTableColumn label="客户名称" prop="consignee" />
                <ElTableColumn label="客户K3代码" prop="king_no" />
                <ElTableColumn label="门店" prop="shop_name" />
                <ElTableColumn label="护理师" prop="sale_name" />
                <ElTableColumn label="收款方式" prop="refund_mode_name" width="130"  />
                <ElTableColumn label="本金" prop="pay_price" v-if="search.type == 3"/>
               <ElTableColumn label="店转" prop="shop_transfer_price" v-if="search.type == 3"/>
                <ElTableColumn label="收款金额" prop="proceeds" v-if="search.type == 3" />
                <ElTableColumn label="待支付金额" prop="paid_amount" v-if="search.type == 4"/>
                <ElTableColumn label="原订单总额" prop="order_amount" v-if="search.type == 4"/>
                <ElTableColumn label="业务类型" prop="business_type"/>
                <ElTableColumn label="订单类型" prop="order_type"/>
                <ElTableColumn label="订单来源" prop="is_app">
                  <template slot-scope="scope">
                    {{ scope.row.is_app }}
                  </template>
                </ElTableColumn>

                <ElTableColumn label="操作" fixed="right" width="160">
                <template slot-scope="{ row }">
                 
                    <span class="theme "  @click="payPrivilege(row)" v-if="row.type == 4 && row.is_show_gopay == 1 && row.refund_mode_name ">去支付</span>
                    <el-popconfirm
                      title="确定取消订单吗？"
                      @confirm="cancel(row)"
                      v-if="row.type == 4 && row.is_show_cancelpay == 1" 
                    >
                      <span class="theme ml-2"  slot="reference" >取消</span>
                    </el-popconfirm>
                    <span class="theme "  @click="payCash(row)" v-if="row.refund_type_plus ==2  && row.type == 3">去支付</span>
                    <span v-if="row.refund_type_plus == 1 && row.type == 3" class="theme ml-2"  @click="payPop(row,'扫码盒子')">立即支付</span>
                    <span v-if="row.refund_type_plus == 3">
                      <span class="theme"  @click="payPop(row,'WeChat')">打印</span>
                    </span>
                </template>
                </ElTableColumn>
            </el-table>
            <div class="reveal" v-if="sum_ben_amount != 'noShow'">
                <span class="mr20">
                本金合计：
                <span class="peril">{{ Number(sum_ben_amount).toFixed(2) }}</span>
                </span>
                <span class="mr20">
                赠金合计：
                <span class="peril">{{ Number(sum_zeng_amount).toFixed(2) }}</span>
                </span>
                <span class="mr20">
                收款金额合计：
                <span class="peril">{{ Number(sum_ben_amount).toFixed(2) }}</span>
                </span>
            </div>
            <pagination
                class="page tc mt10"
                :total="page.total"
                :page.sync="page.page"
                :limit.sync="page.limit"
                @pagination="getList"
            />
            </el-col>
        </el-row>
        <!-- 去支付现金 -->
        <el-dialog title="支付" :visible.sync="cashPopup" width="40%">
          <el-form
            :inline="true"
            ref="payCashFormRef"
            :rules="payCashFormRules"
            size="mini"
            :model="payCashForm"
            label-width="150px"
          >
            
            <el-form-item prop="pay_cash" label="金额:">
              <el-input-number 
                v-model="payCashForm.pay_cash" 
                :min="0"
                :precision="2"
                :step="0.01"
                placeholder="请输入金额"
                class="w400"
                size="max"
                controls-position="right"
              >
                <template slot="prepend">金额：</template>
              </el-input-number>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button  @click="cashPopup = false" style="margin-right: 10px;">取 消</el-button>
            <el-popconfirm
              title="确定支付这些金额吗？"
              @confirm="submitPayCashForm"
            >
              <el-button 
                slot="reference" 
                type="primary"
              >
                确认
              </el-button>
            </el-popconfirm>
          </span>
        </el-dialog>



        <!-- 余额不够情况 -->
      <el-dialog
          title="结算统计"
          :visible.sync="privilegePopup"
          :close-on-click-modal="false"
          width="1000px"
          @close="closeTicket"
        >
      <div class="account-pay-container mb10 fwb">
        <div class="form-row pay-header-row">
          <div class="pay-type-box">
            <span>支付方式：</span>
            <el-select v-model="formData.pay_mode"  size="mini" class="pay-select w120" @change="handlePayModeChange">
              <el-option
                v-for="item in options.payTypeList"
                :key="item.id"
                :label="item.pay_name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="order-amount-box">
            <span>待支付金额：</span>
            <span class="amount-num">{{ Number(formData.orderTotal || 0).toFixed(2) }}元</span>
          </div>
        </div>

        <div class="form-row account-list-row" v-if="formData.pay_mode == 1">
          <div 
            class="account-card" 
            v-for="item in options.yucunList" 
            :key="item.category_id"
          >
            <el-checkbox 
              v-model="item.checked" 
              :label="item.category_id" 
              class="account-radio"
              :disabled="isAccountDisabled(item)"
              @change="(checked) => handleAccountCheck(checked, item)"
            >
              {{ item.category_name }}账户
            </el-checkbox>
            <div class="input-group">
              <label class="input-label">本金：</label>
              <el-input
                v-model="item.balance" 
                readonly
                size="mini" 
                class="w120" 
              />
            </div>
            <div class="input-group">
              <label class="input-label">赠金：</label>
              <el-input
                v-model="item.gift" 
                readonly
                size="mini" 
                class="w120"  
              />
            </div>
            <div class="input-group">
              <label class="input-label">店转：</label>
              <el-input
                v-model="item.transfer" 
                readonly
                size="mini" 
                class="w120" 
              />
            </div>
          </div>
        </div>
        <div style="text-align: right;" v-if="formData.pay_mode == 1">
        <span class="mr20">待支付： 
          <span class="amount-num">   
            {{ Number(formData.pay_balance && formData.pay_balance.length > 0 
            ? formData.pay_balance[formData.pay_balance.length - 1].unpaid 
            : formData.orderTotal) || 0 }}元
          </span>
        </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="isPrivilege" :loading="isSubmitting">确定提交</el-button>
      </span>
    </el-dialog>

        <el-dialog title="扫码盒子支付" :visible.sync="payBoxPop" width="40%">
          <el-form
            :inline="true"
            ref="payCashForm"   
            size="mini"
            :model="payData"
            label-width="150px"
            @submit.native.prevent
          >
            
            <el-form-item  prop="authCode">
              <el-input 
                placeholder="请输入支付授权码" 
                v-model="payData.authCode" 
                class="w600"
                size="max"
                :disabled="isSubmitting"
              >
              <template slot="prepend">支付授权码：</template>
            </el-input>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="payBoxPop = false" :disabled="isSubmitting">取 消</el-button>
            <el-button size="mini" type="primary" @click="submitForm('payBox')" :loading="isSubmitting">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="打印小票" :visible.sync="payQrcodePop" width="40%" >
          <!-- printStart -->
          <div id="printBox" style="margin-left: 30%">
            <div>==================</div>
            <div>====={{ orderData.order_time }}=====</div>
            <div>==================</div>
            <div>订单编号：</div>
            <div>{{orderData.refund_order_no || '-'}}</div>
            <div>==================</div>
            <div>服务中心：</div>
            <div>{{orderData.shop_name || '-'}}</div>
            <div>==================</div>
            <div>客户姓名：</div>
            <span>{{orderData.customer_name || '-'}}</span>
            <div>==================</div>
            <div>实收金额：</div>
            <span>{{ Number(orderData.pay_amount).toFixed(2) }}元</span>
            <div>==================</div>
            <div>====={{ orderData.order_time }}=====</div>
            <div>==================</div>
            <div style="width:100%; height:20px;"></div>
            <div>
              <span>订单二维码：</span>
            </div>
            <div style="width:100%; height:20px;"></div>
            <div id="qrCode" ref="qrCode"></div>
            <div style="width:100%; height:20px;"></div>
            <div>==================</div>
            <div>====={{ orderData.order_time }}=====</div>
            <div>==================</div>
          </div>
          <!-- printEnd -->
          <button @click="printHtml()" class="print-btn">打印</button>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/Pagination";
import {unpaidPayCancel, unpaidPay,unpaidList, getPayType,getCustomerBalance,} from "@/api/order";
import { payBox,getPayUrl,unpaidPayCash } from "@/api/pay";
import QRCode from "qrcodejs2";

class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Search {
  type = 3; // 订单类别
  start_time = "";
  end_time = "";
  consignee = "";
  shop_name = "";
  low_total = "";
  large_total = "";
  business_type = "";
  order_type = "";
}
class Options {
  payTypeList = []; // 支付方式
  typeList = [
    { id: 4, name: "出库单" },
    { id: 3, name: "收款单" }
  ]; // 订单类别
  is_app_List = [
    { id: 0, name: "中台" },
    { id: 1, name: "小程序" }
  ];
  yucunList = []; // 余额
  business_type = [
    { id: 1, name: "疤痕" },
    { id: 2, name: "项目" }
  ];
  order_type = [
    { id: 1, name: "新单" },
    { id: 2, name: "补单" }
  ];
  
}

export default {
  name: "OrderList",
  components: {
    pagination,
    QRCode
  },
  props: {
    clienId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
         payCashFormRules: {
         pay_cash: [
          { required: true, message: '请输入支付金额', trigger: 'blur' },
          {
          validator: (rule, value, callback) => {
  if (value) { // 有输入值时才校验
    const num = Number(value);
    // 1. 校验是否为有效数字，且是否小于0（仅拦截负数，允许0）
    if (isNaN(num) || num < 0) {
      callback(new Error('请输入大于等于0的数'));
    } 
    // 2. 校验小数位数不超过2位
    else if (String(value).indexOf('.') !== -1 && String(value).split('.')[1].length > 2) {
      callback(new Error('支付金额最多保留两位小数'));
    } 
    // 3. 校验通过
    else {
      callback();
    }
  }
  // 无输入值时直接通过（如果需要必填，需额外加required规则）
  callback();
},
            trigger: ['blur', 'change']
          }
        ]
      },
      isSubmitting: false, // 防止重复提交
      loading: false,
      payCashForm: {
        pay_cash: "",
        order_id: ""
      },
      formData: {
        pay_balance: [],
        pay_mode: "",
        order_id: "",
        orderTotal: 0,
      },
      accounts: { // 初始化账户数据
        zc_allgoods_z: 0,
        zc_allfuwu_z: 0
      }, 
      cashPopup: false,
      privilegePopup: false, 
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      page: new Page(), // 分页
      list: [], // 数据展示
      idList: "",
      value1: [],
      sum_ben_amount: "noShow",
      sum_zeng_amount: "",
      payBoxPop: false,
      payQrcodePop: false,
      payData: {
        order_id: "",
        authCode: "",
        type: ""
      }, // 支付信息
      titleMap: {
        WeChatTitle: '微信支付二维码',
        AlipayTitle: '支付宝支付二维码',
      },
      titleName: "",
      orderData: {
        refund_order_no: "",
        shop_name: "",
        customer_name: "",
        pay_amount: "",
        order_time: "",
      },
      privilegeType: 1,
      privilegeTotal: 0,
      isAllOtherAccountDisabled: false,
      isSubmitting: false, // 防止重复提交
      // 表格样式
      cellStyle: {
        padding: '8px 0',
        textAlign: 'center'
      },
      rowClass: {
        background: '#f5f7fa',
        color: '#606266',
        fontWeight: 'bold',
        textAlign: 'center'
      }
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    if(this.$route.query.type){
      this.search.type = parseInt(this.$route.query.type)
    }
    this.getList();
  },
  methods: {
    submitPayCashForm() {
       // 关键修改1：点击立即隐藏弹框，重置状态（解决异步校验时序问题）
      this.$refs.payCashFormRef.validate((valid) => {
      if (valid) {

        this.unpaidPayCash()
      } else {
        return false;
      }
    });      
    },
    unpaidPayCash(){
      
      const loading = this.$loading({
        lock: true,
        text: "提交中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      unpaidPayCash({
        order_id: this.payCashForm.order_id,
        pay_cash: this.payCashForm.pay_cash,
      }).then(res => {
        loading.close();
        if (res.code === 200) {
          this.$message.success('支付成功');     
          this.cashPopup = false;
          this.getList();
        } else {
          this.$message.error(res.msg );
        }
      }).catch(() => {
        loading.close();
      })
    },
    cancel(row) {
      unpaidPayCancel({
        order_id: row.id
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('取消成功');     
          this.getList();
        } else {
          this.$message.error(res.msg || '取消失败');
        }
      });
    },
    payPrivilege(row) {
      this.formData.customer_id = row.customer_id ;
      this.formData.orderTotal = row.paid_amount;
      this.formData.order_id = row.id;
      this.privilegePopup = true;
      this.getPayType1(); 

    },
    payCash(row) {
      this.payCashForm.order_id = row.id;
      this.payCashForm.pay_cash = "";
      this.cashPopup = true;
    },
    submitOrder() {
      const pay_balance = this.formData.pay_balance.map(item => item.category_id);
      console.log( this.formData.pay_balance)
      unpaidPay({
        order_id: this.formData.order_id,
        pay_mode: this.formData.pay_mode,
        pay_balance: pay_balance,
      }).then(res => {
        console.log(res,"eeee")
        this.isSubmitting = false

        if (res.code === 200) {
          if(this.formData.pay_mode == 1 && this.formData.pay_balance[this.formData.pay_balance.length - 1].unpaid > 0){
            this.search.type = 4
            this.getList()
          }else if(this.formData.pay_mode != 1 ||  this.formData.pay_mode == 1 && this.formData.pay_balance[this.formData.pay_balance.length - 1].unpaid == 0){
            this.search.type = 3
            this.getList()
          }

          this.$message.success('支付成功');     
          this.privilegePopup = false;
          this.getList();
        } else {
          this.$message.error(res.msg || '支付失败');
        }
      }).catch(() => {
          this.isSubmitting = false

      });
    },
    isPrivilege () {
      if (!this.formData.pay_mode) {
        this.$message.warning('请选择支付方式  ');
        return;
      }
      if (this.formData.pay_mode === 1 && this.formData.pay_balance.length === 0) {
        return this.$message.warning('请选择至少一个支付账户，若支付账户无法选择，请更换支付方式！');
      }
      this.isSubmitting = true;
      this.submitOrder();
    },
    handlePayModeChange() {
      this.formData.pay_balance = [];
      this.resetAccountCheckbox();
      this.updatePayBalanceUnpaid();
    },
    resetAccountCheckbox() {
      if (Array.isArray(this.options.yucunList) && this.options.yucunList.length > 0) {
        this.options.yucunList.forEach(item => {
          item.checked = false;
        });
      }
      this.isAllOtherAccountDisabled = false;
    },
    updatePayBalanceUnpaid() {
      if (this.formData.pay_balance.length > 0) {
        this.calculateAndUpdateUnpaidFromIndex(0);
      }
    },
    calculateAndUpdateUnpaidFromIndex(startIndex) {
      const { pay_balance } = this.formData;
      const privilegeTotal = Number(this.privilegeTotal) || 0;
      
      for (let i = startIndex; i < pay_balance.length; i++) {
        const currentItem = pay_balance[i];
        const balance = Number(currentItem.balance) || 0;
        const gift = Number(currentItem.gift) || 0;
        const transfer = Number(currentItem.transfer) || 0;
        const accountTotal = balance + gift + transfer;
        
        const baseUnpaid = i === 0 
          ? (Number(this.formData.orderTotal) || 0) - privilegeTotal
          : (Number(pay_balance[i - 1].unpaid) || 0);
        
        let unpaid = Math.max(Number((baseUnpaid - accountTotal).toFixed(2)), 0);
        currentItem.unpaid = unpaid;
      }
      this.isAllOtherAccountDisabled = pay_balance.length > 0 && pay_balance[pay_balance.length - 1].unpaid === 0;
    },
    handleAccountCheck(checked, accountItem) {
      const { pay_balance, orderTotal } = this.formData;
      const { category_id, category_name } = accountItem;
      const privilegeTotal = Number(this.privilegeTotal) || 0;

      const findCategoryIndex = (list, targetId) => {
        return list.findIndex(item => item.category_id === targetId);
      };

      const recalculateAllUnpaid = () => {
        if (pay_balance.length === 0) {
          this.isAllOtherAccountDisabled = false;
          return;
        }
        let totalUsed = pay_balance.reduce((sum, item) => {
          return sum + (Number(item.balance) || 0) + (Number(item.gift) || 0) + (Number(item.transfer) || 0);
        }, 0);
        const orderTotalNum = Number(orderTotal) || 0;
        let finalUnpaid = Math.max(Number((orderTotalNum - privilegeTotal - totalUsed).toFixed(2)), 0);
        pay_balance.forEach((item, index) => {
          pay_balance[index].unpaid = index === pay_balance.length - 1 ? finalUnpaid : 0;
        });
        this.isAllOtherAccountDisabled = finalUnpaid === 0;
      };

      if (checked) {
        const balance = Number(accountItem.balance) || 0;
        const gift = Number(accountItem.gift) || 0;
        const transfer = Number(accountItem.transfer) || 0;
        const accountTotal = balance + gift + transfer;

        const accountData = {
          category_id,
          category_name,
          balance,
          gift,
          transfer,
          unpaid: 0
        };

        const index = findCategoryIndex(pay_balance, category_id);
        if (index === -1) {
          pay_balance.push(accountData);
        }

        recalculateAllUnpaid();
      } else {
        const index = findCategoryIndex(pay_balance, category_id);
        if (index !== -1) {
          pay_balance.splice(index, 1);
          recalculateAllUnpaid();
        }
      }
    },
    isAccountDisabled(currentItem) {
      const balance = Number(currentItem.balance) || 0;
      const gift = Number(currentItem.gift) || 0;
      const transfer = Number(currentItem.transfer) || 0;
      const accountTotal = balance + gift + transfer;
      if (accountTotal <= 0) {
        return true;
      }

      if (currentItem.checked) {
        return false;
      }

      return this.isAllOtherAccountDisabled;
    },
    closeTicket () {
      this.formData.pay_mode = "";
      this.privilegeTotal = 0;
      this.handlePayModeChange();
      this.privilegePopup = false;
    },
    async getPayType1() {
      try {
        const [payTypeRes, balanceRes] = await Promise.all([
          getPayType(),
          this.formData.customer_id ? getCustomerBalance({ customer_id: this.formData.customer_id }) : Promise.resolve({ data: [] })
        ]);
        this.options.payTypeList = payTypeRes.data || [];
        this.options.yucunList = balanceRes.data || [];
      } catch (error) {
        this.$message.error('获取支付信息失败：' + (error.msg || '系统异常'));
      }
    },
    // 获取列表
    async getList(option) {
      try {
        this.loading = true;
        if (option == "search") this.page = new Page();
        // 验证金额输入
        if (this.search.low_total && this.search.large_total) {
          if (Number(this.search.low_total) > Number(this.search.large_total)) {
            return this.$message.warning('最小值不能大于最大值');
          }
        }
        const res = await unpaidList({
          ...this.search,
          ...this.page,
          uid: this.clienId ? this.clienId : "",
          status: "-1",
          is_pay: "0",
        });
        this.list = res.list || [];
        this.page.total = res.dataCount || 0;
        if (this.search.end_time && this.search.type == 3) {
          this.sum_ben_amount = res.sum_ben_amount || 0;
          this.sum_zeng_amount = res.sum_zeng_amount || 0;
        } else {
          this.sum_ben_amount = "noShow";
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message.error('获取订单列表失败：' + (error.msg || '系统异常'));
      }
    },
    // 日期搜索
    searchTime(val) {
      if (val && val.length === 2) {
        this.search.start_time = val[0];
        this.search.end_time = val[1];
      } else {
        this.search.start_time = "";
        this.search.end_time = "";
      }
    },
 
    // 提交支付表单
    submitForm(formName) {
      // 验证授权码
      if (!this.payData.authCode) {
        return this.$message.warning('请输入支付授权码');
      }
      this.hint("立即支付", "提交支付");
    },
    // 提示确认
    hint(text, type) {
      this.$confirm(`${text},是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type == "提交支付") {
            this.payFunction();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 确定支付
    async payFunction() {
      this.isSubmitting = true;
      try {
        const res = await payBox({ ...this.payData });
        this.$message({
          type: "success",
          message: res.msg || '支付成功'
        });
        this.payBoxPop = false;
        this.getList();
      } catch (e) {
        this.$message.error('支付失败：' + (e.msg || '系统异常'));
      } finally {
        this.isSubmitting = false;
      }
    },
    // 支付弹窗触发
    async payPop(row, type) {
      try {
        if (row.refund_type_plus == '1') {
          this.payBoxPop = true;
          this.payData.order_id = row.id;
        }
        if (row.refund_type_plus == '3') {
          this.titleName = type + 'Title';
          this.payQrcodePop = true;
          this.payData.order_id = row.id;
          this.payData.type = type;
          // 请求支付链接
          const res = await getPayUrl({ ...this.payData });
          const data = res.data || {};
          this.orderData = {
            refund_order_no: data.refund_order_no || '',
            shop_name: data.shop_name || '',
            customer_name: data.customer_name || '',
            pay_amount: data.pay_amount || 0,
            order_time: data.time || '',
          };
          const { refund_order_no, shop_id } = data;
          // 拼接二维码链接
          const url = `https://sunburn.178590.com/return/payH5/index.php?refund_order_no=${refund_order_no}&shop_id=${shop_id}`;
          this.$nextTick(() => {
            this.qrCodeCreate(url);
          });
        }
      } catch (error) {
        this.$message.error('获取支付链接失败：' + (error.msg || '系统异常'));
      }
    },
    // 创建二维码
    qrCodeCreate(url) {
      if (!this.$refs.qrCode) return;
      this.$refs.qrCode.innerHTML = "";
      new QRCode(this.$refs.qrCode, {
        text: url,
        width: 150,
        height: 150,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    // 打印功能优化
    printHtml() {
      const printBox = document.getElementById('printBox');
      if (!printBox) return;
      // 保存当前body内容
      const originalContent = document.body.innerHTML;
      // 创建打印专用DOM
      const printContent = document.createElement('div');
      printContent.innerHTML = printBox.innerHTML;
      // 隐藏原内容，显示打印内容
      document.body.innerHTML = '';
      document.body.appendChild(printContent);
      // 执行打印
      window.print();
      // 恢复原内容
      document.body.innerHTML = originalContent;
      // 重新渲染Vue组件（关键）
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
}
.bgW {
  background: #fff;
  padding: 10px;
  margin-bottom: 10px;
}
.search {
  padding: 10px 0;
}
.w220 {
  width: 220px !important;
}
.w84 {
  width: 84px !important;
}
.w120 {
  width: 120px !important;
}
.w600 {
  width: 600px !important;
}
.accountCon {
  background: #fff;
  padding: 10px 0px 80px;
  .btnBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
.reveal {
  text-align: right;
  padding: 20px 0;
  .peril {
    font-weight: bold;
    color: #e6a23c;
  }
  .mr20 {
    margin-right: 20px;
  }
}
.account-pay-container {
  padding: 10px;
  .form-row {
    margin-bottom: 15px;
  }
  .pay-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .account-list-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  .account-card {
    border: 1px solid #e6e6e6;
    padding: 10px;
    border-radius: 4px;
  }
  .input-group {
    margin: 5px;
  }
  .input-label {
    margin-right: 5px;
    color: #666;
  }
  .amount-num {
    color: #e6a23c;
    font-weight: bold;
    font-size: 16px;
  }
}
.mb10 {
  margin-bottom: 10px;
}
.fwb {
  font-weight: bold;
}
.theme {
  cursor: pointer;
}
.ml-2 {
  margin-left: 8px;
}
.page {
  margin-top: 10px;
  text-align: center;
}
.tc {
  text-align: center;
}
.mt10 {
  margin-top: 10px;
}
</style>